<template>
<div class="st-auth-root">
  <div class="st-auth-card">
    <div class="text-center mb-4">
      <img src="assets/images/simi_trac_logo.png" alt="Simi Trac" style="height:50px;" />
      <h4 class="mt-3" style="color:#E8EDF4;font-weight:700;">Reset Password</h4>
      <p style="color:#8BA4C4;font-size:14px;">Enter your email to receive a reset link</p>
    </div>
    <div class="st-alert st-alert-danger" v-if="error">{{ error }}</div>
    <div class="st-alert st-alert-success" v-if="success">{{ success }}</div>
    <div class="mb-3"><label class="st-label">Email</label><input type="email" class="st-input" v-model="email" placeholder="you@school.ac.ke" /></div>
    <button class="btn st-btn-primary w-100" @click="reset" :disabled="loading"><span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>Send Reset Link</button>
    <p class="text-center mt-3"><a href="javascript:void(0)" @click="$router.push('/login')" class="st-link">Back to Sign In</a></p>
  </div>
</div>
</template>
<script>
export default {
  name: "ResetPassword",
  data() { return { email: '', loading: false, error: '', success: '' }; },
  methods: {
    async reset() {
      if (!this.email) { this.error = 'Email is required'; return; }
      this.loading = true; this.error = '';
      setTimeout(() => { this.success = 'If an account exists with this email, a reset link has been sent.'; this.loading = false; }, 1500);
    }
  }
};
</script>
<style scoped>
.st-auth-root{min-height:100vh;display:flex;align-items:center;justify-content:center;background:#0A1628;padding:20px;}
.st-auth-card{background:#0F2347;border:1px solid #1A3A6A;border-radius:20px;padding:40px;width:100%;max-width:440px;box-shadow:0 20px 60px rgba(0,0,0,.3);}
.st-label{color:#8BA4C4;font-size:13px;font-weight:600;margin-bottom:6px;display:block;}
.st-input{width:100%;background:#0A1628;border:1px solid #1A3A6A;border-radius:10px;padding:10px 14px;color:#E8EDF4;font-size:14px;outline:none;transition:border .2s;}
.st-input:focus{border-color:#2E86DE;}
.st-input::placeholder{color:#4A6B8A;}
.st-select{width:100%;background:#0A1628;border:1px solid #1A3A6A;border-radius:10px;padding:10px 14px;color:#E8EDF4;font-size:14px;outline:none;}
.st-btn-primary{background:linear-gradient(135deg,#2E86DE,#1A6BC4);color:#fff;border:none;font-weight:600;border-radius:10px;padding:12px;font-size:15px;transition:all .2s;}
.st-btn-primary:hover{background:linear-gradient(135deg,#4FC3F7,#2E86DE);box-shadow:0 4px 20px rgba(46,134,222,.4);}
.st-btn-primary:disabled{opacity:.6;}
.st-link{color:#4FC3F7;text-decoration:none;font-size:13px;font-weight:500;}
.st-link:hover{text-decoration:underline;}
.st-alert{padding:10px 14px;border-radius:10px;font-size:13px;margin-bottom:16px;}
.st-alert-danger{background:rgba(255,107,107,.1);border:1px solid rgba(255,107,107,.2);color:#FF9999;}
.st-alert-success{background:rgba(16,185,129,.1);border:1px solid rgba(16,185,129,.2);color:#6EE7B7;}</style>